import { render, staticRenderFns } from "./FooteR.vue?vue&type=template&id=4ed93f12&"
import script from "./FooteR.vue?vue&type=script&lang=js&"
export * from "./FooteR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports